import React from 'react';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-sage-600 text-white pt-16 pb-8">
      {/* Smooth Wave Shape for Mobile & Desktop */}
      <div className="absolute top-0 left-0 right-0 overflow-hidden leading-none" style={{ transform: 'translateY(-99%)' }}>
        <svg className="relative block w-full" style={{ height: '150px' }} preserveAspectRatio="none" viewBox="0 0 1440 120" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,64 C320,100,420,20,740,64 C1060,108,1140,28,1440,64 L1440,120 L0,120 Z" fill="#82A284" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_kove-bookings/artifacts/7jf1fq47_IMG_8942.jpeg"
                alt="Kove Logo"
                className="h-12 w-12 rounded-full object-cover ring-2 ring-white"
              />
              <div>
                <h3 className="text-xl font-serif">Kove</h3>
                <p className="text-xs text-gray-200 tracking-wider">THE STUDIO</p>
              </div>
            </div>
            <p className="text-white font-light text-sm leading-relaxed">
              Your intimate hair sanctuary in Middleton Loop, Albany.
            </p>
            <div className="mt-4 space-y-2 text-sm text-white font-light">
              <p>Middleton Loop, Albany WA</p>
              <p>
                <a href="tel:0475409162" className="hover:text-white transition-colors duration-200">
                  0475 409 162
                </a>
              </p>
              <p>
                <a href="https://www.instagram.com/kove.thestudio" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200">
                  @kove.thestudio
                </a>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-normal mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2 text-sm text-white">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white hover:text-cream-100 transition-colors duration-200 font-light">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-white hover:text-cream-100 transition-colors duration-200 font-light">
                  Gallery
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-white hover:text-cream-100 transition-colors duration-200 font-light">
                  About
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-white hover:text-cream-100 transition-colors duration-200 font-light">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-normal mb-4 text-white">How to Book</h4>
            <div className="space-y-3 text-sm text-white font-light leading-relaxed">
              <p><strong className="text-white font-normal">New Clients:</strong> Please text us with:</p>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Photo of your current hair</li>
                <li>Inspiration pictures</li>
                <li>Brief colour history</li>
                <li>Preferred dates/times</li>
              </ul>
              <p className="pt-2 text-xs">We can't answer calls while with clients, so texting is preferred.</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-sage-700 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-white">
          <p className="font-light mb-4 md:mb-0">
            © {new Date().getFullYear()} Kove the Studio. All rights reserved.
          </p>
          <div className="flex items-center space-x-4">
            <a href="sms:0475409162" className="hover:text-white transition-colors duration-200 font-light">
              Book Now
            </a>
            <a href="https://www.instagram.com/kove.thestudio" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Made By Credit */}
        <div className="mt-6 text-center">
          <a
            href="https://www.layerly.com.au"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-white/70 hover:text-white transition-colors duration-200 font-light"
          >
            Made By Layerly
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;